import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
import { Container, Row, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Notification, { showToast } from "../../../../components/common/notification/Notification";
import useSubscriptionPlans from "./useSubscriptionPlans";
import useUserDetails from "./useUserDetails";
// eslint-disable-next-line no-unused-vars
import PaymentPlans from "./PaymentPlans";
import PlanCard from "./PlanCard";
import { Accordion } from "react-bootstrap";
import Api from "../../../components/api/Api";

const UserPayment = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const userId = loggedInUser?.user?.id;

  const userDetails = useUserDetails(userId);
  // eslint-disable-next-line no-unused-vars
  const addApi = Api({
    url: `/api/payments/add/subscription`,
  });
  const {
    plans,
    selectedPlan,
    setSelectedPlan,
    expandedPlan,
    setExpandedPlan,
    // eslint-disable-next-line no-unused-vars
    loading: plansLoading
  } = useSubscriptionPlans();

  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  // eslint-disable-next-line no-unused-vars
  const razorpay_key = process.env.REACT_APP_RAZORPAY_KEY;

  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [apiLoading, setApiLoading] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const fetchOrderId = async () => {
    setApiLoading(true);
    try {
      const payload = {
        user_id: userId.toString(),
        rating: 0,
        subscription_plan_id: setSelectedPlan,
        is_registration: true,
      };

      const response = await axios.post(`${baseUrl}/payments/getRazorPaymentOrderId`, payload);

      if (response.data.statusType === "SUCCESS") {
        localStorage.setItem("paymentAmount", response.data.amount);
        return { orderId: response.data.orderId, amount: response.data.amount.toString() };
      }

      showToast("Order ID fetch failed", { type: "error" });
      return null;
    } catch (err) {
      showToast("Network error. Try again.", { type: "error" });
      return null;
    } finally {
      setApiLoading(false);
    }
  };

  return (
    <Container fluid>
      <Notification />

      <Row className="justify-content-center">
        <Col xs={12} lg={10}>
          <div className="card shadow border-0 rounded-3 p-4 my-2 profile-card">
            <Accordion activeKey={expandedPlan?.toString()}>
              {plans.map((plan) => (
                <PlanCard
                  key={plan.id}
                  plan={plan}
                  selectedPlan={selectedPlan}
                  expandedPlan={expandedPlan}
                  setSelectedPlan={setSelectedPlan}
                  setExpandedPlan={setExpandedPlan}
                  userDetails={userDetails}
                />
              ))}
            </Accordion>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default UserPayment;
